import { Box, Stack, Typography } from "@mui/material";

import {
  staffCalendarLegendItems,
  staffCalendarToneSx,
  type StaffCalendarGridMode,
} from "./staff-calendar-status-tokens";

type StaffCalendarLegendProps = {
  mode: StaffCalendarGridMode;
  /** When false (portal-only), pending leave swatch is hidden from the legend. */
  showPendingLeave?: boolean;
  /** Optional note below legend items (e.g. portal pending visibility). */
  portalNote?: string;
};

export function StaffCalendarLegend({
  mode,
  showPendingLeave = true,
  portalNote,
}: StaffCalendarLegendProps) {
  const items = staffCalendarLegendItems(mode, { showPendingLeave });
  const ariaLabel = mode === "leave" ? "Leave status legend" : "Attendance legend";

  return (
    <Stack spacing={0.75} sx={{ mb: mode === "attendance" ? 1.5 : 0.5 }}>
      <Stack direction="row" flexWrap="wrap" gap={1.5} alignItems="center" aria-label={ariaLabel}>
        {items.map((item) => (
          <Stack key={item.id} direction="row" spacing={0.75} alignItems="center">
            <Box
              sx={[
                {
                  minWidth: 28,
                  height: 28,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 0.5,
                  typography: "caption",
                  fontWeight: 700,
                },
                (theme) => staffCalendarToneSx(theme, item.tone),
              ]}
            >
              {item.symbol}
            </Box>
            <Typography variant="caption" color="text.secondary">
              {item.label}
            </Typography>
          </Stack>
        ))}
      </Stack>
      {portalNote ? (
        <Typography variant="caption" color="text.secondary">
          {portalNote}
        </Typography>
      ) : null}
    </Stack>
  );
}
